import { Audit } from '.';

export enum ProgramStatusCode {
  CREATED = 100,
  DELETED = 900,
}

/**
 * BambuProgram is the interface for the response of the Program API
 */
export interface BambuProgram {
  programId: number;
  name: string;
  abbreviation: string;
  brandId: number;
  templateId?: number;
  tenantId: number;
  statusCode: ProgramStatusCode;
  status: string;
  color?: string;
  logo?: string;
  audit: Audit;
  externalIdentifier?: string;
}

/**
 * BambuProgramInput is the interface for the input of the Program API
 */
export interface BambuProgramInput {
  name: string;
  abbreviation?: string;
  brandId: number;
  tenantId: number;
  templateId?: number;
  logo?: string;
  color?: string;
  statusCode?: ProgramStatusCode;
  imageFile?: string | Buffer;
}
